// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsTensileSamplePreparation_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 0H10L16 4V13L11 15.8947V24H9V14.9989L13.9987 11.9997V4.99967L9.4987 1.99967H6.4987L1.9987 4.99967V11.9997L6.9987 14.9997H7V24H5V15.8947L0 13V4L6 0Z" class="svg-bg"/>
  <path d="M14.6833 22.3656C14.0885 22.2432 13.5234 22.0396 13 21.7668V19.3539C13.7961 20.0662 14.8471 20.4992 15.9994 20.4992C18.4847 20.4992 20.4994 18.4845 20.4994 15.9992C20.4994 14.2326 19.4814 12.7037 18 11.9673V9.8125C18.5602 9.99347 19.0872 10.2484 19.5693 10.5658L21.3048 9.98736L22.0119 10.6945L21.4334 12.43C21.8769 13.1038 22.1984 13.865 22.3666 14.6823L24 15.499V16.499L22.3666 17.3157C22.1985 18.1328 21.877 18.8939 21.4336 19.5677L22.0116 21.3018L21.3045 22.0089L19.571 21.4311C18.8967 21.8753 18.1348 22.1973 17.3167 22.3656L16.5 23.999H15.5L14.6833 22.3656Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsTensileSamplePreparation is a generated icon component.
 */
let IconRmsTensileSamplePreparation = IconRmsTensileSamplePreparation_1 = class IconRmsTensileSamplePreparation extends IconBaseElement {
    render() {
        return html `${IconRmsTensileSamplePreparation_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsTensileSamplePreparation.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsTensileSamplePreparation = IconRmsTensileSamplePreparation_1 = __decorate([
    customElement('zui-icon-rms-tensile-sample-preparation')
], IconRmsTensileSamplePreparation);
export { IconRmsTensileSamplePreparation };
